/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const DonationIcon = createIcon(
  '0 0 20 20',
  <g>
    <path d="M8.481 5.192a2 2 0 0 1 1.047 2.752L8.5 10h1.98a4 4 0 0 0 2.657-1.01l2.51-2.232A3 3 0 0 1 17.642 6H19l-2.633 7.898A6 6 0 0 1 10.676 18H2v-8a4.16 4.16 0 0 0 3.249-1.562L8 5z" />
    <path d="M14.148 1C15.17 1 16 1.78 16 2.742c0 .439-.172.84-.457 1.146C14.558 4.948 12.5 7 12.5 7s-2.058-2.053-3.043-3.112A1.68 1.68 0 0 1 9 2.742C9 1.78 9.83 1 10.852 1c.718 0 1.34.383 1.648.943.308-.56.93-.943 1.648-.943" />
  </g>,
);
